/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable max-lines */

import { CustomSankeyLayerProps, DefaultLink, DefaultNode } from '@nivo/sankey';
import React from 'react';
import { Coords } from './makeCustomSankey';

export type CustomSankeyNode = {
  x: number;
  y: number;
  height: number;
  width: number;
  label: string | string[];
};

type CustomSankeyNodesProps = {
  customNodes: Record<string, CustomSankeyNode>;
  hover: string;
  setHover: React.Dispatch<React.SetStateAction<string>>;
  setCoords: React.Dispatch<React.SetStateAction<Coords | null>>;
};

const CustomSankeyNodes: React.FC<
  CustomSankeyLayerProps<DefaultNode, DefaultLink> & CustomSankeyNodesProps
> = (props) => {
  const { customNodes, hover, setHover, setCoords } = props;

  const handleMouseEnter = (event: React.MouseEvent<Element>, id: string): void => {
    setCoords({
      left: event.pageX,
      top: event.pageY,
    });
    setHover(id);
  };

  const node = (nodeProps: CustomSankeyNode & { key: string }): JSX.Element => {
    const { key, x, y, height, width: nodeWidth, label } = nodeProps;

    return (
      <g
        key={key}
        transform={`translate(${x}, ${y})`}
        className="cursor-pointer"
        onMouseEnter={(e): void => {
          handleMouseEnter(e, key);
        }}
        onMouseLeave={(): void => {
          setHover('');
        }}
        onMouseMove={(e): void => {
          handleMouseEnter(e, key);
        }}
      >
        <rect
          key="complete"
          height={height}
          width={nodeWidth}
          rx={4}
          ry={4}
          fill="white"
          stroke="#858585"
          transform="translate(0,0)"
          className="cursor-pointer"
          style={{
            pointerEvents: 'all',
            filter:
              hover === key
                ? 'drop-shadow(3px 1px 8px rgba(0, 0, 0, 0.5))'
                : 'drop-shadow(3px 1px 8px rgba(0, 0, 0, 0.35))',
          }}
        />
        {Array.isArray(label) ? (
          <g
            transform={`translate(12, ${height / 2}) rotate(-90)`}
            dominantBaseline="central"
            textAnchor="middle"
          >
            <text transform="translate(0, 0)" className="text-menu-item">
              {label[0]}
            </text>
            <text transform="translate(0, 15)" className="text-menu-item">
              {label[1]}
            </text>
          </g>
        ) : (
          <text
            dominantBaseline="central"
            textAnchor="middle"
            transform={`translate(10, ${height / 2}) rotate(-90)`}
            className="text-menu-item"
          >
            {label}
          </text>
        )}
      </g>
    );
  };

  return <>{Object.entries(customNodes).map(([k, n]) => node({ ...n, key: k }))}</>;
};

export default CustomSankeyNodes;
